import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import DigitalTeamPage from "@/pages/DigitalTeamPage";
import ErstgespraechPage from "@/pages/ErstgespraechPage";
import "@/pages/DigitalTeamPage.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/digitales-team" element={<DigitalTeamPage />} />
        <Route path="/erstgespraech" element={<ErstgespraechPage />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
